// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"383cf2c7","237":"383cf2c7","300":"383cf2c7","688":"1ffdf7f1","884":"d2f9cdc6","918":"383cf2c7","921":"383cf2c7"}[chunkId] + ".chunk.css";
};